export const companyInitialState = {
	companies: null,
	error: null,
	errorShow: false,
	loading: false,
};
